import GraphicMultiSelectQuestion from './GraphicMultiSelectQuestion';

export default GraphicMultiSelectQuestion;
